<template>
    <v-row justify="center">
      <v-dialog v-model="open" width="640px" scrollable>
        <v-card class="grid">
          <!-- close -->
          <v-toolbar elevation="0" class="title">
            <span class="pl-5">{{
              $t('message.pages.customizeModal.thisCycleDetails')
            }}</span>
            <v-spacer />
            <v-toolbar-items>
              <v-btn icon @click="handleClose">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
  
          <!-- steps -->
          <v-card-text
            v-if="prorataData"
            class="my-0 py-0 pl-6 pr-8"
            :class="moreDetails ? 'pl-6 pr-8' : 'pl-10 pr-12'"
            style="height: 450px"
          >
            <v-row no-gutters>
              <v-col cols="12" class="columnTitle mb-2">
                <v-row no-gutters>
                  <v-col cols="10">
                    <span>ITEM</span>
                  </v-col>
                  <v-col cols="2">
                    <v-row no-gutters justify="end">
                      <span>{{ $t('message.pages.customizeModal.price') }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-row
                no-gutters
                v-for="(prorateObject, i) in prorataObjects"
                :key="i"
              >
                <v-row
                  no-gutters
                  class="pa-2 text--month-listing border-bottom--gray"
                  :class="{
                    'text--month-listing--dark': $vuetify.theme.dark,
                  }"
                >
                  <v-col cols="12">
                    <span class="text-caption text--secondary">
                      {{ timeConverter(prorateObject.start) }}
                      - {{ timeConverter(prorateObject.end) }},
                      {{ new Date(prorateObject.end * 1000).getFullYear() }}
                      <b
                        v-if="getProhataLabel(prorateObject)"
                        class="text--current-month"
                      >
                        <template
                          v-if="getProhataLabel(prorateObject) === 'current'"
                        >
                          ({{
                            $t(
                              'message.pages.customizeModal.proportionalCurrentMonth'
                            )
                          }})
                        </template>
                        <template
                          v-if="getProhataLabel(prorateObject) === 'next'"
                        >
                          ({{
                            $t(
                              'message.pages.customizeModal.proportionalNextMonth'
                            )
                          }})
                        </template>
                      </b>
                    </span>
                  </v-col>
                </v-row>
                <v-row
                  no-gutters
                  v-for="(objLine, i) in prorateObject.objects"
                  :key="i"
                  style="width: 100%; line-height: 15px !important"
                  class="pl-2 pr-0 py-4 border-bottom--gray"
                >
                  <v-row no-gutters>
                    <v-col>
                      <span
                        class="text-caption text--primary"
                        style="line-height: 15px !important"
                        >{{ objLine.description }}
                      </span>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                      <span class="text-caption"
                        ><b>
                          {{
                            (objLine.amount / 100).toLocaleString(
                              currencyLocale,
                              { style: 'currency', currency: currency }
                            )
                          }}
                        </b></span
                      >
                    </v-col>
                  </v-row>
                </v-row>
              </v-row>
              <v-col cols="12" class="mx-auto pt-5" v-if="prorataData.subtotal">
                <v-row no-gutters>
                  <v-col class="d-flex justify-end">
                    <span class="text-caption"><b>Subtotal</b></span>
                    <span
                      class="text-caption d-flex justify-end"
                      style="width: 110px"
                      ><b>{{
                        (prorataData.subtotal / 100).toLocaleString(
                          currencyLocale,
                          { style: 'currency', currency: currency }
                        )
                      }}</b></span
                    >
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="prorataData.discount">
                <v-col cols="12" class="mx-auto mt-1">
                  <v-row no-gutters v-if="prorataData.discount.coupon.amount_off">
                    <v-col class="d-flex justify-end">
                      <span class="text-caption">{{
                        `${prorataData.discount.coupon.name} (${(
                          prorataData.discount.coupon.amount_off / 100
                        ).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })} off)`
                      }}</span>
                      <span
                        class="text-caption d-flex justify-end"
                        style="width: 110px"
                        ><b
                          >-{{
                            (prorataData.discount.amount / 100).toLocaleString(
                              currencyLocale,
                              { style: 'currency', currency: currency }
                            )
                          }}</b
                        ></span
                      >
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-else>
                    <v-col class="d-flex justify-end">
                      <span class="text-caption">{{
                        `${prorataData.discount.coupon.name} (${prorataData.discount.coupon.percent_off}% off)`
                      }}</span>
                      <span
                        class="text-caption d-flex justify-end"
                        style="width: 110px"
                        ><b
                          >-{{
                            (prorataData.discount.amount / 100).toLocaleString(
                              currencyLocale,
                              { style: 'currency', currency: currency }
                            )
                          }}</b
                        ></span
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <v-col cols="12" class="mx-auto mt-1">
                <v-row no-gutters>
                  <v-col class="d-flex justify-end">
                    <span class="text-caption"><b>Total</b></span>
                    <span
                      class="text-caption d-flex justify-end"
                      style="width: 110px"
                    >
                      <b v-if="prorataData.total">{{
                        (prorataData.total / 100).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                      }}</b>
                      <b v-else>{{
                        (0).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                      }}</b>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                class="mx-auto mt-1"
                v-if="prorataData.starting_balance"
              >
                <v-row no-gutters>
                  <v-col class="d-flex justify-end">
                    <span class="text-caption grey--text">{{
                      $t('message.pages.customizeModal.appliedDescount')
                    }}</span>
                    <span
                      class="text-caption d-flex justify-end"
                      style="width: 110px"
                      ><b>{{
                        (prorataData.starting_balance / 100).toLocaleString(
                          currencyLocale,
                          { style: 'currency', currency: currency }
                        )
                      }}</b></span
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-4">
                <v-row no-gutters>
                  <v-col cols="10">
                    <span
                      ><b>{{
                        $t('message.pages.customizeModal.totalToNext')
                      }}</b></span
                    >
                  </v-col>
                  <v-col cols="2" v-if="prorataData && prorataData.amount_due">
                    <v-row no-gutters justify="end">
                      <span
                        ><b>{{
                          (prorataData.amount_due / 100).toLocaleString(
                            currencyLocale,
                            {
                              style: 'currency',
                              currency: currency,
                            }
                          )
                        }}</b></span
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  
  export default {
    name: 'CustomizePlanDetails',
    components: {},
    data: () => ({
      open: false,
      prorataObjects: null,
      prorataData: null,
      items: [],
      moreDetails: false,
      currency: 'brl',
      currencyLocale: 'pt-BR',
    }),
    computed: {
      ...mapState({
        userPlanInfo: (state) => state.user.userPlanInfo,
      }),
    },
    mounted() {
      this.$root.$on(
        'openCustomizePlanDetailsFirst',
        (prorataObjects, allProrateData) => {
          this.handleOpenedModal()
          this.open = true
          this.prorataObjects = prorataObjects
          this.prorataData = allProrateData
        }
      )
    },
    beforeDestroy() {
      this.$root.$off('openCustomizePlanDetailsFirst')
    },
    methods: {
      handleOpenedModal() {
        this.setCurrencyConfig()
      },
      getLocale() {
        if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
        return 'pt-BR'
      },
      timeConverter(timestamp) {
        let a = new Date(timestamp * 1000)
        let locale = this.getLocale().toLowerCase()
        let months
        if (locale === 'en-us') {
          months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ]
        } else {
          months = [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Maio',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ]
        }
        let month = months[a.getMonth()]
        let date = a.getDate()
        let time = month + ' ' + date
        return time.toUpperCase()
      },
      getProhataLabel({ end }) {
        if (this.isCurrentMonth({ end })) return 'current'
        if (this.isNextMonth({ end })) return 'next'
        return false
      },
      isCurrentMonth({ end }) {
        const dateObject = new Date(end * 1000)
        return (
          dateObject.getMonth() ===
          new Date(this.getPayTimeStamp * 1000).getMonth()
        )
      },
      isNextMonth({ end }) {
        const dateObject = new Date(end * 1000)
        return (
          dateObject.getMonth() ===
          new Date(this.getPayTimeStamp * 1000).getMonth() + 1
        )
      },
      setCurrencyConfig() {
        const currency = this.userPlanInfo.currency
        if (currency === 'usd') {
          this.currency = 'usd'
          this.currencyLocale = 'en-US'
          return
        } else {
          this.currency = 'brl'
          this.currencyLocale = 'pt-BR'
        }
      },
      handleClose() {
        this.open = false
      },
      handleMoreDetails() {
        this.moreDetails = true
      },
      backToMain() {
        this.moreDetails = false
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .title {
    font-weight: 500;
    font-size: 18px;
  }
  .columnTitle {
    font-weight: 400;
    font-size: 12px;
  }
  .columnRow {
    font-weight: 400;
    font-size: 16px;
  }
  .text--current-month {
    text-transform: uppercase;
  }
  
  .text--month-listing {
    background: var(--v-progressBar-lighten1);
  }
  
  .text--month-listing--dark {
    background: #60606038;
  }
  
  .border-bottom--gray {
    border-bottom: 1px solid #cdcdcd;
  }
  </style>
  